import Lottie from "react-lottie";
import Paragraph from "src/components/Paragraph";
import SectionHeading from "src/components/SectionHeading";
import Translate from "src/components/Translate";
import constants from "src/constants";
import * as lottieHolding from "src/icons/Lottie-holding.json";

const PricesSubscription = () => {
  return (
    <>
      <SectionHeading
        title="Subscription"
        subtitle="Get instant access to a huge amount of videos and indulge in unlimited mental wellness."
      />
      <div className="subscription-info">
        <div className="icon-circle">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieHolding,
            }}
            width={64}
            height={64}
          />
        </div>
        <Paragraph size="nm">
          <Translate tKey="We take a fair approach to our community members and instructors. The majority of the prize, namely 70 to 81% of the paid amount, is obtained by the instructors. We thus support authors and their work. Thank you for helping us change and grow the world of online yoga, movement and therapy." />
        </Paragraph>
      </div>
    </>
  );
};

export default PricesSubscription;
